const e = "_wrapper_pk0f3_1", p = "_innerWrapper_pk0f3_4", r = "_label_pk0f3_14", _ = "_details_pk0f3_18", a = "_bold_pk0f3_23", l = {
  wrapper: e,
  innerWrapper: p,
  label: r,
  details: _,
  bold: a
};
export {
  a as bold,
  l as default,
  _ as details,
  p as innerWrapper,
  r as label,
  e as wrapper
};
